import { OpenInNewWindowIcon } from '@radix-ui/react-icons'

import { ButtonLink } from 'slab'

function ReferralPageLinkButton ({ publicPageURL }: { publicPageURL: string }) {
  return (
    <ButtonLink
      href={publicPageURL}
      target='_blank'
      variant='secondary'
      rel='noopener noreferrer'
      leftIcon={OpenInNewWindowIcon}
      onClick={() => {
        window.segment?.track('[TfB] View referral page button clicked')
      }}
    >
      <span className='ml-1'>View your page</span>
    </ButtonLink>
  )
}

export default ReferralPageLinkButton
